import { Add, Delete } from "@mui/icons-material";
import React, { useState } from "react";
import MarketTimeDropdown from "../markets-time-dropdown";
import NodataAvailable from "../../../assets/images/NodataAvailable.svg";
import { Button } from "../../../components/ui";
const options = [
  { label: "12:00 AM", value: "12:00 AM" },
  { label: "01:00 AM", value: "01:00 AM" },
  { label: "02:00 AM", value: "02:00 AM" },
  { label: "03:00 AM", value: "03:00 AM" },
  { label: "04:00 AM", value: "04:00 AM" },
  { label: "05:00 AM", value: "05:00 AM" },
  { label: "06:00 AM", value: "06:00 AM" },
  { label: "07:00 AM", value: "07:00 AM" },
  { label: "08:00 AM", value: "08:00 AM" },
  { label: "09:00 AM", value: "09:00 AM" },
  { label: "10:00 AM", value: "10:00 AM" },
  { label: "11:00 AM", value: "11:00 AM" },
  { label: "12:00 PM", value: "12:00 PM" },
  { label: "01:00 PM", value: "01:00 PM" },
  { label: "02:00 PM", value: "02:00 PM" },
  { label: "03:00 PM", value: "03:00 PM" },
  { label: "04:00 PM", value: "04:00 PM" },
  { label: "05:00 PM", value: "05:00 PM" },
  { label: "06:00 PM", value: "06:00 PM" },
  { label: "07:00 PM", value: "07:00 PM" },
  { label: "08:00 PM", value: "08:00 PM" },
  { label: "09:00 PM", value: "09:00 PM" },
  { label: "10:00 PM", value: "10:00 PM" },
  { label: "11:00 PM", value: "11:00 PM" },
];

const daysList = ["S", "M", "T", "W", "T", "F", "S"];

const AuctionScheduler: React.FC<{
  schedules: any;
  backupSchedules: any;
  handleAddAuction: any;
  handleDeleteAuction: any;
  handleSelectOption: any;
  revertAllDays: any;
  applyToAllDays: any;
  handleToggleDay: any;
  activeDay: number;
  setActiveDay: any;
  showRevert: boolean;
}> = ({
  schedules,
  backupSchedules,
  activeDay,
  setActiveDay,
  handleAddAuction,
  handleDeleteAuction,
  handleSelectOption,
  revertAllDays,
  applyToAllDays,
  handleToggleDay,
  showRevert,
}) => {
  return (
    <div className="">
      {/* Tabs */}
      <div className="flex justify-between items-center pb-4 border-b">
        <div className="flex gap-2">
          {daysList.map((day, i) => (
            <button
              key={i}
              onClick={() => setActiveDay(i)}
              className={`w-8 h-8 rounded-full border text-sm font-semibold ${
                activeDay === i
                  ? "bg-primary text-white border-primary"
                  : "bg-white color-sub-text border-gray hover:bg-[#D7F3DD]"
              }`}
            >
              {day}
            </button>
          ))}
        </div>

        <div className="flex gap-3">
          <Button
            variant="outlined-primary"
            data-shape="round"
            onClick={applyToAllDays}
            className="h-[35px]"
          >
            Apply to All Days
          </Button>
          {showRevert && (
            <button
              onClick={revertAllDays}
              className="border border-red-500 color-red px-3 py-1 br-30 text-sm hover:bg-red-100"
            >
              Revert All
            </button>
          )}
        </div>
      </div>

      {/* Schedule Section */}
      <div className="bg-white  ">
        <div className="flex gap-4 items-center w-100 py-4 border-b">
          <div className="flex flex-col  w-20">
            <div className="flex items-center gap-1">
              <h3 className="font-semibold color-text-primary fs-14">
                {
                  [
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                  ][activeDay]
                }
              </h3>
              <div
                onClick={() => handleToggleDay(activeDay)}
                className={`relative w-8 h-[18px] rounded-full transition-colors duration-300 cursor-pointer
      ${schedules[activeDay].enabled ? "bg-primary" : "bg-gray-300"}`}
              >
                <div
                  className={`absolute top-[3px]  h-3 w-3 rounded-full bg-white transition-transform duration-300
        ${
          schedules[activeDay].enabled
            ? "translate-x-5 left-[-4px]"
            : "translate-x-0 left-[1px]"
        }`}
                />
              </div>
            </div>
            <label className="flex items-center gap-2 fs-12 color-sub-text">
              Working Hours
            </label>
          </div>
          {schedules[activeDay].enabled && (
            <div className="flex items-center gap-4  w-70">
              <div className="flex flex-col w-100">
                <span className="text-sm color-sub-text ">From:</span>
                <MarketTimeDropdown
                  options={options}
                  selected={schedules[activeDay].workingHours.from}
                  onChange={(value) =>
                    handleSelectOption(
                      value,
                      activeDay,
                      "working",
                      null,
                      "from"
                    )
                  }
                  placeholder="Opens at..."
                />
              </div>
              <div className="flex flex-col w-100">
                <span className="text-sm color-sub-text ">To:</span>
                <MarketTimeDropdown
                  options={options}
                  selected={schedules[activeDay].workingHours.to}
                  onChange={(val) =>
                    handleSelectOption(val, activeDay, "working", null, "to")
                  }
                  placeholder="Closes at..."
                />
              </div>
            </div>
          )}
          <div className="w-10"></div>
        </div>
        {schedules[activeDay].enabled && (
          <div className="pt-4">
            <div className="flex justify-between">
              <div>
                <h3 className="font-semibold color-text-primary fs-14">
                  Auction Time
                </h3>
                <label className="flex items-center gap-2 fs-12 color-sub-text">
                  Working Hours
                </label>
              </div>
              <Button
                variant="outlined-primary"
                data-shape="round"
                onClick={() => handleAddAuction(activeDay)}
                className="h-[35px]"
              >
                <Add style={{ fontSize: 16 }} />
                Add Auction Time
              </Button>
            </div>
            {/* Auction Rows */}
            {schedules[activeDay].auctions.length > 0 ? (
              <>
                {schedules[activeDay].auctions.map(
                  (a: any, i: number) =>
                    a.status !== 0 && (
                      <div
                        key={i}
                        className="flex items-center w-full gap-4 space_18"
                      >
                        <div className="w-20">
                          <h3 className="font-semibold color-text-primary fs-14">
                            Auction #{i + 1}
                          </h3>
                          <label className="flex items-center gap-2 fs-12 color-sub-text">
                            {
                              [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday",
                              ][activeDay]
                            }
                          </label>
                        </div>
                        <div className="flex gap-4 w-70">
                          <div className="flex flex-col w-100">
                            <span className="text-sm  color-sub-text">
                              From:
                            </span>
                            <MarketTimeDropdown
                              options={options}
                              selected={a.from}
                              onChange={(val) =>
                                handleSelectOption(
                                  val,
                                  activeDay,
                                  "auction",
                                  i,
                                  "from"
                                )
                              }
                              placeholder="From Time..."
                            />
                          </div>
                          <div className="flex flex-col w-100">
                            <span className="text-sm color-sub-text ">To:</span>
                            <MarketTimeDropdown
                              options={options}
                              selected={a.to}
                              onChange={(val) =>
                                handleSelectOption(
                                  val,
                                  activeDay,
                                  "auction",
                                  i,
                                  "to"
                                )
                              }
                              placeholder="To Time..."
                            />
                          </div>
                        </div>
                        <div
                          onClick={() => handleDeleteAuction(activeDay, i)}
                          className="ml-2 bg-red-100 hover:bg-red-200 p-2 rounded-full color-red cursor-pointer flex items-center justify-center  w-[30px] h-[30px]"
                        >
                          <Delete style={{ fontSize: 16 }} />
                        </div>
                      </div>
                    )
                )}
              </>
            ) : (
              <div className="flex items-center justify-center h-full">
                <img src={NodataAvailable} alt="No data available" />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default AuctionScheduler;
